(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/big/assets/javascripts/views/big-statistics-header_desktop.js') >= 0) return;  svs.modules.push('/components/statistics/big/assets/javascripts/views/big-statistics-header_desktop.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.views = svs.statistics.big.views || {};

  svs.statistics.big.views.BigStatisticsHeader = Backbone.Marionette.View.extend(
    {
      template: function(bigStatModel) {
        if (
          bigStatModel.periodResultText &&
          bigStatModel.match &&
          bigStatModel.match.league &&
          bigStatModel.match.league.sport &&
          bigStatModel.match.league.sport.id === svs.statistics.constants.TENNIS
        ) {
          bigStatModel.periodResultText = bigStatModel.periodResultText.replace(
            '*',
            '<i class="icon-default tennis-ball icon-game-tennis"></i>'
          );
        }

        return svs.statistics.big.templates.big_header(bigStatModel);
      },

      events: {
        'click .js-fav-star': 'openFavorite',
        'click .big-play-now': 'playNow',
        'click .outcome': 'outcomeClick'
      },

      modelEvents: {
        'change:matchInitText': 'initChange',
        change: 'render'
      },

      ui: {
        favoriteButton: '.big-favorite-button',
        rendered1X2buttons: '.js-rendered-1X2-buttons',
        header: '.js-big-header-background'
      },

      outcomeClick: function(evt) {
        this.model.get('drawEventButtons').outcomeClick(evt);
      },

      log: new svs.core.log.Logger(
        'svs.statistics.big.views.BigStatisticsHeader'
      ),

      initialize: function(options) {
        if (_.isObject(this.model) && this.model.get('hasMatch')) {
          this.favorite = new svs.sport.views.GameFavorites({
            app: options.app,
            event: this.model.get('match'),
            contextmenu: false,
            headerClass: options.favoritesModalHeaderClass,
            buttonClass: 'btn-transparent-inverted'
          });
          this.listenTo(
            svs.sport.views.GameFavoriteGlobalEvents,
            'change-favorites',
            this.favoriteChanged
          );
          this.listenTo(this.favorite, 'change', this.renderFavoriteButton);
        }
      },

      favoriteChanged: function() {
        var starButton = this.$el.find('.js-favorite-icon');

        if (starButton) {
          starButton.toggleClass('icon-star-empty').toggleClass('icon-star');
        }
        this.render();
      },

      initChange: function(model) {
        this.model.get('initObject').status.text = model.get('matchInitText');
      },

      openFavorite: function() {
        if (this.model.get('hasMatch') && this.model.get('showFavStar')) {
          this.favorite.openFavorite();
        }
      },

      renderFavoriteButton: function() {
        if (
          _.isObject(this.model) &&
          this.model.get('hasMatch') &&
          this.model.get('showFavStar')
        ) {
          this.ui.favoriteButton.html(this.favorite.favoriteButton);
        }
      },

      playNow: function() {
        var self = this;
        if (_.isObject(this.model) && this.model.get('playNowCallback')) {
          this.model.get('playNowCallback')();
        } else if (this.model.get('showPlayNow')) {
          svs.core.module.load(
            '/cl/sport/oddset-play',
            null,
            function() {
              svs.sport.oddsetplay.showPlayNow(
                self.model.get('draws').oddsetDraws.drawNumber
              );
            },
            false
          );
        }
        return false;
      },

      getTennisGroundType: function(match) {
        var groundType = '-hardcourt';

        if (
          _.isObject(match.additionalInfos) &&
          !_.isUndefined(match.additionalInfos)
        ) {
          var type = _.find(match.additionalInfos, function(info) {
            if (
              info.description.toLowerCase() ===
              svs.statistics.constants.GROUND_TYPE
            ) {
              return info;
            }
          });

          if (type && type.value) {
            if (type.value.toLowerCase().indexOf('hardcourt') >= 0) {
              groundType = '-hardcourt';
            } else if (type.value.toLowerCase().indexOf('gräs') >= 0) {
              groundType = '-grass';
            } else if (type.value.toLowerCase().indexOf('grus') >= 0) {
              groundType = '-gravel';
            }
          }
        }

        return groundType;
      },

      renderHeaderBackground: function() {
        if (_.isObject(this.model) && this.model.hasSport()) {
          var match = this.model.get('match'),
            sportType =
              match.league && match.league.sport
                ? match.league.sport.type
                : match.sport
                ? match.sport.type
                : undefined,
            groundType = '';

          if (sportType) {
            if (sportType === 6) {
              groundType = this.getTennisGroundType(match);
            }

            this.ui.header.addClass(
              'big-header-sport-' + sportType + groundType
            );
          } else {
            var sportId = this.model.get('match').league.sport.id;

            if (sportId) {
              this.ui.header.addClass('big-header-sport-' + sportId);
            }
          }
        }
      },

      onRender: function() {
        this.renderFavoriteButton();
        if (_.isObject(this.model) && this.model.get('drawEventButtons')) {
          this.ui.rendered1X2buttons.html(
            this.model.get('drawEventButtons').render().el
          );
        }

        this.renderHeaderBackground();

        this.delegateEvents();
      },

      onDestroy: function() {
        if (this.favorite && this.favorite.destroy) {
          this.favorite.destroy();
        }
      }
    }
  );
})(Backbone, _, svs);

 })(window);